<div class="flex flex--align-center">
  <mat-form-field>
    <mat-label>{{ 'shared.month-picker.title' | translate }}</mat-label>
    <input
      matInput
      [matDatepicker]="dp"
      [matDatepickerFilter]="dateFilter"
      [formControl]="date"
      (dateChange)="onDateChanged($event.value)"
      [disabled]="true"
    />
    <mat-datepicker-toggle matIconSuffix [for]="datepicker"></mat-datepicker-toggle>
    <mat-datepicker
      #dp
      startView="multi-year"
      (yearSelected)="chosenYearHandler($event)"
      (monthSelected)="chosenMonthHandler($event, dp)"
      #datepicker
      [disabled]="false"
    >
    </mat-datepicker>
  </mat-form-field>
</div>
